import {Select} from '@hconnect/common/components'
import {ControlledFormField, FormFieldBase, SelectOption} from '@hconnect/common/types'
import {Controller, FieldValues} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {DalogActionPriority} from '../../types'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    onChange?: (value: DalogActionPriority | undefined) => void
  }

export const DalogPriorityField = <TField extends FieldValues>(props: Props<TField>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options: SelectOption<DalogActionPriority>[] = Object.values(DalogActionPriority).map(
    (priority) => ({
      value: priority,
      label: t(`dalogActions.priority.${priority}`)
    })
  )

  return (
    <Controller
      name={props.name}
      control={props.control}
      disabled={props.disabled || props.readOnly}
      render={({field, fieldState}) => (
        <Select
          data-test-id={`select-field-${field.name}`}
          name={field.name}
          options={options}
          label={props.label}
          value={field.value}
          onChange={(value) => {
            field.onChange(value)
            props.onChange?.(value)
          }}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={props.disabled}
          required={props.required}
          optional={props.optional}
          readOnly={props.readOnly}
        />
      )}
    />
  )
}
